<h5 class="mb-4 enterprisePolicy"> Publish Enterprise Policy</h5>
<div>
    <label class="ms-2" for="">Policy Text and/or HiperLink: </label>
    <br>
    <textarea class="ms-2 gir-textarea" type="textarea" [(ngModel)]="enterprisePolicyString">
    </textarea>
    <br>
    <button class="btn btn-action-primary text-nowrap ms-2" (click)="publishEnterPrisePolicyAPI()"> Save </button>
    <p class="displayCenter"> {{eventMessage }}</p>
</div>